import { User } from './../types';
import firebase from '@/plugins/firebase';
import * as Type from '@/types';

let database: firebase.firestore.Firestore = firebase.firestore();

const userCache: { [uid: string]: User; } = {};
const projectCache: { [projectId: string]: Type.Project; } = {};
const collectionCache: { [collectionId: string]: Type.Collection; } = {};
const entryCache: { [entryId: string]: Type.Entry; } = {};

export async function getUserData(uid: string): Promise<Type.User> {
    if (userCache[uid]) {
        return await userCache[uid];
    } else {
        const doc = await database.collection('users').doc(uid).get();
        userCache[uid] = <User>doc.data();
        return doc.data() as Type.User;
    }
}

export async function getProjectData(projectId: string): Promise<Type.Project> {
    if (projectCache[projectId]) {
        return await projectCache[projectId];
    } else {
        const doc = await database.collection('projects').doc(projectId).get();
        const project = doc.data() as Type.Project;
        projectCache[projectId] = project;
        return project;
    }
}

export async function getCollectionData(collectionId: string): Promise<Type.Collection> {
    if (collectionCache[collectionId]) {
        return await collectionCache[collectionId];
    } else {
        const doc = await database.collection('collections').doc(collectionId).get();
        const collection = doc.data() as Type.Collection;
        collectionCache[collectionId] = collection;
        return collection;
    }
}

export async function getEntryData(entryId: string): Promise<Type.Entry> {
    if (entryCache[entryId]) {
        return await entryCache[entryId];
    } else {
        const doc = await database.collection('entries').doc(entryId).get();
        const entry = doc.data() as Type.Entry;
        entryCache[entryId] = entry;
        return entry;
    }
}

export async function getHistoryData(transcriptionId: string, historyId: string) {
    //console.log(transcriptionId, historyId)
    const doc = await database.collection('transcriptions').doc(transcriptionId).collection('history').doc(historyId).get();
    return doc.data() as Type.ITranscriptionHistory;
}


export async function likeTimelineEvent(eventId: string, liked: boolean) {
    const doc = await database.collection('timeline').doc(eventId);
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) return;
    const uid = currentUser.uid;
    return doc.update(`likes.${uid}`, liked);
}